import React, { useState } from "react";
import { useAuthContext } from "../../contexts/AuthContext";
import Loader from "../UI/Loader";
import Sidebar from "../UI/Sidebar";
import Stats from "../INTERNAL_DASHBOARDS/SalesStats/Stats";
import StatsThisLastMonth from "../INTERNAL_DASHBOARDS/SalesStats/StatsThisLastMonth";
import StatsLastMonth from "../INTERNAL_DASHBOARDS/SalesStats/StatsLastMonth";
import StatsThisQuarter from "../INTERNAL_DASHBOARDS/SalesStats/StatsThisQuarter";
import StatsLastQuarter from "../INTERNAL_DASHBOARDS/SalesStats/StatsLastQuarter";

const isDevelopment = process.env.NODE_ENV === "development";

const SalesStats = () => {
  const [view, setView] = useState("ThisMonth");
  const context = useAuthContext();

  if (!context?.ready) {
    return <Loader />;
  }

  const handleViewChange = (newView) => {
    setView(newView);
  };

  return (
    <>
      <Sidebar />
      <div className="content">
        <div className="sales-stats">
          <div className="button-group">
            <button
              className={view === "ThisLastMonth" ? "active" : ""}
              onClick={() => handleViewChange("ThisLastMonth")}
            >
              This Month vs Last Month
            </button>
            <button
              className={view === "ThisMonth" ? "active" : ""}
              onClick={() => handleViewChange("ThisMonth")}
            >
              This Month
            </button>
            <button
              className={view === "LastMonth" ? "active" : ""}
              onClick={() => handleViewChange("LastMonth")}
            >
              Last Month
            </button>
            <button
              className={view === "ThisQT" ? "active" : ""}
              onClick={() => handleViewChange("ThisQT")}
            >
              This Quarter
            </button>
            <button
              className={view === "LastQT" ? "active" : ""}
              onClick={() => handleViewChange("LastQT")}
            >
              Last Quarter
            </button>
          </div>

          <div className="stats-container">
            {view === "ThisLastMonth" && <StatsThisLastMonth />}
            {view === "ThisMonth" && <Stats />}
            {view === "LastMonth" && <StatsLastMonth />}
            {view === "ThisQT" && <StatsThisQuarter />}
            {view === "LastQT" && <StatsLastQuarter />}
          </div>
        </div>
      </div>
    </>
  );
};

export default SalesStats;
